import React, { useContext } from "react"
import { POSContext } from "src/main/PointOfSale/Layout"

import Button from "src/components/Button"

export default function CompletedCart() {
  const {
    cartController: { clearCart },
  } = useContext(POSContext)

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <h1 className="mt-[15%] font-semibold">Cart checked out</h1>
      <p>This cart has been checked out and can no longer be changed</p>
      <Button variant="primary" onClick={clearCart}>
        Start a New Sale
      </Button>
    </div>
  )
}
